import gettext from '@sdk/lang/gettext';
import useToast from '@sdk/common/toast/useToast';

import { ONBOARDING_TOAST_ID } from '@web/onboarding/Checklist/onboardingChecklist.consts';

const useSubmitWages = (submit: () => Promise<any>, afterSubmitCallback: () => void) => {
  const { showSuccessToast } = useToast();

  const submitWages = async () => {
    try {
      await submit();
      showSuccessToast(gettext('Wages have been added'), {
        containerId: ONBOARDING_TOAST_ID,
      });
      afterSubmitCallback();
    } catch {
      // no need to catch as form object contains errors if submit failed.
    }
  };

  return submitWages;
};

export default useSubmitWages;
